import { Box, Flex } from "rebass";
import AlertBannerCommunication from "../../AlertBannerCommunication/AlertBannerCommunication";
import AlertBannerInfo from "../../AlertBannerInfo/AlertBannerInfo";
import AlertBannerWarning from "../../AlertBannerWarning/AlertBannerWarning";
import Carousel from "react-multi-carousel";
import { useMemo, useRef, useState } from "react";
import ChevronDown from "../../../../icons/ChevronDown";

const BannerWrapper = ({ banners, cookieUpdate }) => {
  const lang = localStorage.getItem("B2BLanguage") === "ITA" ? "it" : "en";

  const carouselRef = useRef();

  const [currentSlideIndex, setCurrentSlideIndex] = useState(0);
  const responsive = {
    mobile: {
      breakpoint: { max: 40000, min: 0 },
      items: 1,
    },
  };

  const activeBanners = useMemo(() => {
    return banners?.filter((banner) => !banner?.closed) || [];
  }, [banners]);

  const onClickCarouselItem = (bannerId) => {
    cookieUpdate(bannerId);
    if (carouselRef?.current) {
      carouselRef?.current.goToSlide(0);
    }
  };
  return (
    <Flex width={1} sx={{ position: "relative" }}>
      {activeBanners.length > 1 && (
        <Carousel
          ref={carouselRef}
          responsive={responsive}
          dotListClass="banners-wrapper-dots"
          afterChange={(previousSlide, { currentSlide, onMove }) => {
            setCurrentSlideIndex(currentSlide);
          }}
          autoPlay
          autoPlaySpeed={8000}
          arrows={false}
          showDots
          rewind
        >
          {activeBanners.map((banner) => {
            if (banner?.typeId === 3)
              return (
                <AlertBannerCommunication
                  key={banner?.id}
                  visibleButton={banner?.collapsed}
                  onClick={() => onClickCarouselItem(banner?.id)}
                >
                  {banner?.message?.[lang] || ""}
                </AlertBannerCommunication>
              );
            if (banner?.typeId === 2)
              return (
                <AlertBannerWarning
                  key={banner?.id}
                  visibleButton={banner?.collapsed}
                  onClick={() => onClickCarouselItem(banner?.id)}
                >
                  {banner?.message?.[lang] || ""}
                </AlertBannerWarning>
              );
            if (banner?.typeId === 1)
              return (
                <AlertBannerInfo
                  key={banner?.id}
                  visibleButton={banner?.collapsed}
                  onClick={() => onClickCarouselItem(banner?.id)}
                >
                  {banner?.message?.[lang] || ""}
                </AlertBannerInfo>
              );
          })}
        </Carousel>
      )}
      {activeBanners?.length === 1 &&
        activeBanners.map((banner) => {
          if (banner?.typeId === 3)
            return (
              <AlertBannerCommunication
                key={banner?.id}
                visible={!banner?.closed}
                visibleButton={banner?.collapsed}
                onClick={() => cookieUpdate(banner?.id)}
              >
                {banner?.message?.[lang] || ""}
              </AlertBannerCommunication>
            );
          if (banner?.typeId === 2)
            return (
              <AlertBannerWarning
                key={banner?.id}
                visible={!banner?.closed}
                visibleButton={banner?.collapsed}
                onClick={() => cookieUpdate(banner?.id)}
              >
                {banner?.message?.[lang] || ""}
              </AlertBannerWarning>
            );
          if (banner?.typeId === 1)
            return (
              <AlertBannerInfo
                key={banner?.id}
                visible={!banner?.closed}
                visibleButton={banner?.collapsed}
                onClick={() => cookieUpdate(banner?.id)}
              >
                {banner?.message?.[lang] || ""}
              </AlertBannerInfo>
            );
        })}
      <Box
        sx={{
          height: "100%",
          position: "absolute",
          right: 0,
          display: ["none", "flex"],
        }}
      >
        <button
          style={{
            background: "transparent",
            ...(currentSlideIndex === 0 && {
              opacity: 0.25,
              pointerEvents: "none",
            }),
          }}
          onClick={() => {
            if (carouselRef?.current) {
              carouselRef?.current.previous();
            }
          }}
        >
          <ChevronDown
            style={{
              width: "18px",
              height: "18px",
              transform: "rotate(90deg)",
              stroke: "#fff",
            }}
          />
        </button>
        <button
          style={{
            marginRight: "3px",
            background: "transparent",
            ...(currentSlideIndex === activeBanners?.length - 1 && {
              opacity: 0.25,
              pointerEvents: "none",
            }),
          }}
          onClick={() => {
            if (carouselRef?.current) {
              carouselRef?.current.next();
            }
          }}
        >
          <ChevronDown
            style={{
              width: "18px",
              height: "18px",
              transform: "rotate(-90deg)",
              stroke: "#fff",
            }}
          />
        </button>
      </Box>
    </Flex>
  );
};

export default BannerWrapper;
